import React from 'react'
import Header from '../Header/Header';
import Grade1 from "../../../../components/Gradechart/GradeData"

function Grade() {
    return (
        <div>
              <Header label="Grade Statistics"/>
              <Grade1/>
        </div>
    )
}

export default Grade
